<template>
  <!-- 下载 -->
  <div class="">
    <v-dialog
    name="basic-t"
    v-model="isShow"
    :title="dialogTitle"
    :close-on-click-modal="closeOnClickModal1"
    :modal="true"
    :width="560"
    :height="204"
    @confirm="handleConfirm"
    @after-close="handleAfterClose"
    v-bind:confirmButtonText= "suredown"
    append-to-body
  >
  确定要开始下载文件(ID:{{UseId}})吗？
  </v-dialog>
    </div>
</template>

<script>
// import OSS from 'ali-oss'

export default {
  components: {},
  props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    UseId:{
    },
    file_url:{
      type:String,
      default:""
    }
  },
  data() {
    return {
        dialogTitle: "下载",
        closeOnClickModal1: false, //点击周围关闭弹窗
        suredown:"下载",
        filename_all:'',
        filename:'',
        isShow:false,

    };
  },
  watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
  methods: {
    async getData(){
				window.location.href = this.file_url;
        this.$emit('update:showInputDialog',false)

    },
    handleConfirm() {
      if(!this.file_url){
        this.$message.error('无下载文件！')
        this.$emit('update:showInputDialog',false)

      }else{
        this.getData()
      }
    },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)

      },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">

</style>
